import { useMutation } from '@tanstack/react-query';

import { SiteFormSchemaValues } from 'src/features/sites/utils/formSchema';
import { Site } from 'src/features/sites/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/site/:siteId/`;

type MutationFnType = typeof mutationFn;

interface DTO {
    data: SiteFormSchemaValues;
    siteId: string;
    parkingId: string;
}
const mutationFn = ({ siteId, parkingId, data }: DTO): Promise<Site> => {
    return axios.put(formatResourcePath(RESOURCE, { siteId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSite };
